<template>
	<div>
		<div class="home-page">
			<div class="bg"></div>
			<div @click="handleShow" class="suspension">环节介绍</div>
			<div class="content">
				<div @click="handleGoKcqd" class="book">
					<img src="./../../assets/home/kcqd.png" alt srcset />
				</div>
				<div class="bottom-box">
					<div class="bottom-title">
						<div>本考核由镜下读片和模拟接诊组成</div>
						<!-- <div>均为选择题</div> -->
					</div>
					<div class="title-num">
						您还剩余{{ initData&&initData.remainingTimes||0 }}次考核机会
					</div>
					<!-- <div class="title-num">
						本考核由镜下读片和模拟接诊组成
					</div> -->
					<!-- <img src="./../../assets/home/home-bg.png" alt srcset /> -->
					<div @click="handleGoMicroscope" class="btn">开始考核</div>
					<!-- <div class="br"></div>
					<div class="txt" v-if="initData">
						<div class="gz-title">本环节初始考核机会为2次</div>
						<div>
							可以通过点击上方学习中心进行皮肤病知识学习。根据学习时长来获取
							<span>额外考核机会</span>
							，每学习30分钟可获得一次机会。最多获得2次额外考试机会，本环节考核机会上限4次，<span>取最高分作为最终成绩。</span>
						</div>
						<div>
							<span>您默认有两次答题机会，答题完毕后可通过做任务获得额外2次机会，总计4次答题机会。</span>
						</div>
					</div> -->
				</div>
			</div>
			<!-- <div class="btn" @click="cleanExamData">
        点击清除次数，返回上一页再进入可继续答题
      </div> -->
			<van-popup v-model="isShow" position="bottom">
				<div class="gz">
					<div class="title">
						<div class="txt">线上实操规则</div>
						<div @click="handleClose" class="close">
							<img src="./../../assets/home/closes.png" alt />
						</div>
					</div>
					<div class="img">
						<img v-if="isStudentUser" class="icon" src="./../../assets/home/xssc2.png" alt />
						<img v-else class="icon" src="./../../assets/home/xssc3.png" alt />
						<!-- <image :src="baseStaticURL+'static/home/gz.png'" mode="widthFix"></image> -->
					</div>
				</div>
			</van-popup>
			<van-popup v-model="popupNode">
				<div class="node-view">
					<div class="node-view-title">提示</div>
					<div class="node-view-des">答题次数已用完，点击获取次数</div>
					<div class="node-view-btn" @click="nodeBtnClick">
						<div>立即前往</div>
					</div>
					<div class="node-view-btn-see" @click="popupNode=false">
						<div>我知道了</div>
					</div>
				</div>
			</van-popup>
		</div>
		<van-dialog v-model="imgAmplify" :showConfirmButton="false" :closeOnClickOverlay="true" class="dialogImg">
			<div class="imgAmplify">
				<img v-if="imgStatus === 1" src="./../../assets/home/certificate.png" alt />
				<img v-if="imgStatus === 2" src="./../../assets/home/felidae.png" alt />
			</div>
		</van-dialog>
		<div class="mask" v-if="errorShow"></div>
		<div class="dialog" v-if="errorShow">
			<div class="text mt130">{{ errortext1 }}</div>
			<div class="text">{{ errortext2 }}</div>
			<div @click="handleCloseError" class="btn">确认</div>
		</div>
		<van-overlay :show="loadingShow">
			<div class="flexAuto">
				<van-loading vertical type="spinner" />
			</div>
		</van-overlay>

	</div>
</template>

<script>
	import {
		mapMutations
	} from "vuex";
	import {
		login
	} from "@/api/system/login";
	import wx from "weixin-js-sdk";
	import {
		setToken
	} from "@/utils/cookie";
	import {
		isEnd,
		getIndexUserData,
		cleanMyExamData
	} from "@/api/system/exam";
	import {
		getPetPaper,
		getSlidePaper
	} from "../../api/system/exam";
	export default {
		name: "Home2026",
		data() {
			return {
				isdebugger: false,
				loadingShow: true,
				type: true,
				imgAmplify: false,
				imgStatus: false,
				isShow: false,
				errorShow: false,
				errortext1: "当前考核已截止",
				errortext2: "请查看其他活动",
				isMicroscope: false,
				isPetScore: false,
				isEnd: true,
				// 初始化获取数据
				initData: null,
				popupNode: false,
				isStudentUser: false,
			};
		},
		created() {},

		mounted() {
			if (window.history && window.history.pushState) {
				history.pushState(null, null, document.URL);
				window.addEventListener("popstate", this.goPageBefore, false);
			}
			if (this.isdebugger) {
				this.getInit();
			} else {
				if (!this.$route.query.isLogin) {
					if (
						this.$route.query.hospitalName &&
						this.$route.query.nickName &&
						this.$route.query.sign &&
						this.$route.query.timestamp &&
						this.$route.query.userId
					) {
						this.getInit();
					} else {
						this.errorShow = true;
						this.errortext1 = "登录异常";
						this.errortext2 = "请联系管理员";
					}
				} else {
					this.loadingShow = false;
				}
			}
			if (this.$route.query.isStudentUser && this.$route.query.isStudentUser == 'true') {
				this.isStudentUser = true
			} else {
				this.isStudentUser = false
			}
			this.getIsEnd();
			// 清除数据
			//this.clearData();

		},
		destroyed() {
			window.removeEventListener("popstate", this.goPageBefore, false);
		},
		methods: {
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
			...mapMutations("microscope", ["handleMicroscope"]),
			handleGoMicroscopeStart() {
				getSlidePaper().then((res) => {
					this.handleMicroscope({
						key: "slidePaper",
						value: res.data.data.slidePaperModels,
					});
					this.handleMicroscope({
						key: "microscopeModleTime",
						value: true
					});
					this.handleMicroscope({
						key: "examDetailId",
						value: res.data.data.examDetailId
					});
					this.handleMicroscope({
						key: "statePauseCount",
						value: res.data.data.remainPauseTime
					});
					this.handleMicroscope({
						key: "microscopeTimeNum",
						value: res.data.data.remainTimes
					});
					this.handleMicroscope({
						key: "microscopeTimeNum",
						value: res.data.data.remainTimes
					});
					this.handleMicroscope({
						key: "isPause",
						value: res.data.data.examStatus ? true : false,
					});
					this.handleMicroscope({
						key: "activeIndex",
						value: res.data.data.slideComplete + 1,
					});

					//玻片考试是否完成 0-未完成 1-已完成，则去拉取宠物试卷
					if (res.data.data.slideComplete) {
						this.handleMicroscope({
							key: "microscopeModleTime",
							value: false
						});
						this.handleMicroscope({
							key: "activeIndex",
							value: 2
						});
						getPetPaper().then((response) => {
							this.VISUAL_EXAMINATION({
								key: "treatmentList",
								value: response.data.data
							});
							if (res.data.data.currentAnswer) {
								let currentAnswer = res.data.data.currentAnswer

								let answers = JSON.parse(currentAnswer.answers)
								if (currentAnswer.questionId != 4) {
									this.VISUAL_EXAMINATION({
										key: "ttreatmentEcho",
										value: answers.treatmentEcho
									});
									this.VISUAL_EXAMINATION({
										key: "tdetailsz2",
										value: answers.detailsz2
									});
									this.VISUAL_EXAMINATION({
										key: "tdetail",
										value: answers.detail
									});
									this.VISUAL_EXAMINATION({
										key: "tdetail3",
										value: answers.detail3
									});
									this.VISUAL_EXAMINATION({
										key: "tdetailstepPre3",
										value: answers.detailstepPre3
									});
									this.VISUAL_EXAMINATION({
										key: "tdetail4",
										value: answers.detail4
									});
									this.VISUAL_EXAMINATION({
										key: "tdetail5",
										value: answers.detail5
									});
								}


								if (currentAnswer.questionId == '-1') {
									let dic = JSON.parse(currentAnswer.paperId)
									this.VISUAL_EXAMINATION({
										key: "submitFlag",
										value: false
									});
									this.VISUAL_EXAMINATION({
										key: "selectPosition",
										value: dic.arr
									});
									this.VISUAL_EXAMINATION({
										key: "selectPositionObj",
										value: dic.item
									});
									this.$router.replace({
										path: "/treat/mouth",
										query: {
											list: response.data.data.step2Questions[parseInt(dic
												.index)],
										},
									});
									return
								} else if (currentAnswer.questionId == '-2') {
									let ans = JSON.parse(currentAnswer.paperId)
									this.VISUAL_EXAMINATION({
										key: "selectPositionObj",
										value: ans.obj
									});
									this.VISUAL_EXAMINATION({
										key: "selectPosition",
										value: ans.arr
									});
									this.$router.replace({
										path: "/treat/point"
									});
									return
								} else if (currentAnswer.questionId == '-3') {
									let ans = JSON.parse(currentAnswer.paperId)
									this.VISUAL_EXAMINATION({
										key: "submitFlag",
										value: false
									});
									this.VISUAL_EXAMINATION({
										key: "mouthModalFlag",
										value: true
									});
									this.VISUAL_EXAMINATION({
										key: "selectPosition",
										value: ans.arr
									});
									const obj = {
										id: ans.id,
										accomplish: true,
									};
									this.VISUAL_EXAMINATION({
										key: "selectPositionObj",
										value: obj
									});
									this.$router.replace({
										path: "/treat/point"
									});
									return
								} else if (currentAnswer.questionId == '-4') {
									this.VISUAL_EXAMINATION({
										key: "selectPosition",
										value: JSON.parse(currentAnswer.paperId)
									});
									this.VISUAL_EXAMINATION({
										key: "mouthModalFlag",
										value: true
									});
									const obj = {
										id: 5,
										accomplish: true,
									};
									this.VISUAL_EXAMINATION({
										key: "selectPositionObj",
										value: obj
									});
									this.$router.replace({
										path: "/treat/mouthTwo",
										query: {
											list: response.data.data.step2Questions[5],
										},
									});
									return
								} else if (currentAnswer.questionId == '-5') {
									this.$router.replace(currentAnswer.paperId);
									return
								} else if (currentAnswer.questionId == '-6') {
									const obj = {
										stepTwo: true,
										stepThree: true,
										stepFour: true,
										stepFive: false,
										stepSix: false,
									};
									this.VISUAL_EXAMINATION({
										key: "contentObj",
										value: obj
									});
									this.VISUAL_EXAMINATION({
										key: "overIndex",
										value: 3
									});
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 3.1
										},
									});
									return
								} else if (currentAnswer.questionId == '-7') {
									this.$router.replace({
										path: "/treat/clinicaltwo",
										// query: this.clinicalObj,
										query: response.data.data.step4Questions,
									});
									return
								} else if (currentAnswer.questionId == '-8') {
									const obj = {
										stepTwo: true,
										stepThree: true,
										stepFour: true,
										stepFive: true,
										stepSix: false,
									};
									this.VISUAL_EXAMINATION({
										key: "contentObj",
										value: obj
									});
									this.VISUAL_EXAMINATION({
										key: "overIndex",
										value: 4
									});
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 4.1
										},
									});
									return
								} else if (currentAnswer.questionId == '-9') {
									const obj = {
										stepTwo: true,
										stepThree: true,
										stepFour: true,
										stepFive: true,
										stepSix: true,
									};
									this.VISUAL_EXAMINATION({
										key: "contentObj",
										value: obj
									});
									this.VISUAL_EXAMINATION({
										key: "overIndex",
										value: 5
									});
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 5.1
										},
									});
									return
								} else if (currentAnswer.questionId == '-10') {
									this.$router.replace({
										path: "/treat/affirmTwo",
									});
									return
								} else if (currentAnswer.questionId == '-11') {
									this.VISUAL_EXAMINATION({
										key: "overIndex",
										value: 6
									});
									this.VISUAL_EXAMINATION({
										key: "treatModleTime",
										value: false
									});
									this.$router.replace({
										// path: "/treat/examineResult",
										// 第二个版本
										path: "/treat/assemble",
									});
									return
								} else if (currentAnswer.questionId == '-205') {
									this.$router.replace("/treat/Catalog");
									return
								} else if (currentAnswer.questionId == '-206') {
									this.$router.replace({
										path: "/treat/complaint"
									});
									return
								} else if (currentAnswer.questionId == '-207') {
									this.$router.replace("/treat/pruritus");
									return
								} else if (currentAnswer.questionId == '-208') {
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 1.1
										},
									});
									return
								} else if (currentAnswer.questionId == '-209') {
									const obj = {
										stepTwo: true,
										stepThree: false,
										stepFour: false,
										stepFive: false,
										stepSix: false,
									};
									this.VISUAL_EXAMINATION({
										key: "contentObj",
										value: obj
									});
									this.VISUAL_EXAMINATION({
										key: "overIndex",
										value: 1
									});
									this.$router.replace("/treat/Catalog");
									return
								} else if (currentAnswer.questionId == '-2010') {
									let ans = JSON.parse(currentAnswer.paperId)
									if (Array.isArray(ans)) {
										this.VISUAL_EXAMINATION({
											key: "selectPosition",
											value: ans
										});
									}

									this.$router.replace({
										path: "/treat/point"
									});
									return
								} else if (currentAnswer.questionId == '-2011') {
									this.VISUAL_EXAMINATION({
										key: "submitFlag",
										value: false
									});
									const obj = {
										stepTwo: true,
										stepThree: true,
										stepFour: false,
										stepFive: false,
										stepSix: false,
									};
									this.VISUAL_EXAMINATION({
										key: "contentObj",
										value: obj
									});
									this.VISUAL_EXAMINATION({
										key: "overIndex",
										value: 2
									});
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 2.1
										},
									});
									return
								} else if (currentAnswer.questionId == '-2012') {
									this.VISUAL_EXAMINATION({
										key: "submitFlag",
										value: false
									});
									this.VISUAL_EXAMINATION({
										key: "selectPosition",
										value: JSON.parse(currentAnswer.paperId)
									});
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 2
										},
									});
									return
								} else if (currentAnswer.questionId == '-2013') {
									if (currentAnswer.paperId == '2.1') {
										const obj = {
											stepTwo: true,
											stepThree: true,
											stepFour: false,
											stepFive: false,
											stepSix: false,
										};
										this.VISUAL_EXAMINATION({
											key: "contentObj",
											value: obj
										});
										this.VISUAL_EXAMINATION({
											key: "overIndex",
											value: 2
										});
									} else if (currentAnswer.paperId == '3.1') {
										const obj = {
											stepTwo: true,
											stepThree: true,
											stepFour: true,
											stepFive: false,
											stepSix: false,
										};
										this.VISUAL_EXAMINATION({
											key: "contentObj",
											value: obj
										});
										this.VISUAL_EXAMINATION({
											key: "overIndex",
											value: 3
										});
									} else if (currentAnswer.paperId == '4.1') {
										const obj = {
											stepTwo: true,
											stepThree: true,
											stepFour: true,
											stepFive: true,
											stepSix: false,
										};
										this.VISUAL_EXAMINATION({
											key: "contentObj",
											value: obj
										});
										this.VISUAL_EXAMINATION({
											key: "overIndex",
											value: 4
										});
									} else if (currentAnswer.paperId == '5.1') {
										const obj = {
											stepTwo: true,
											stepThree: true,
											stepFour: true,
											stepFive: true,
											stepSix: true,
										};
										this.VISUAL_EXAMINATION({
											key: "contentObj",
											value: obj
										});
										this.VISUAL_EXAMINATION({
											key: "overIndex",
											value: 5
										});
									}
									this.$router.replace("/treat/Catalog");
									return
								} else if (currentAnswer.questionId == '-2014') {
									this.$router.replace({
										path: "/treat/distinguish"
									});
									return
								} else if (currentAnswer.questionId == '-2015') {
									this.$router.replace({
										path: "/treat/clinical"
									});
									return
								} else if (currentAnswer.questionId == '-2016') {
									this.$router.replace({
										path: "/treat/final"
									});
									return
								} else if (currentAnswer.questionId == '-2017') {
									this.$router.replace({
										path: "/treat/affirm"
									});
									return
								} else if (currentAnswer.questionId == '-2018') {
									this.$router.replace({
										path: "/treat/examineResult"
									});
									return
								} else if (currentAnswer.questionId == '-2019') {
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 3
										},
									});
									return
								} else if (currentAnswer.questionId == '-2020') {
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 4
										},
									});
									return
								} else if (currentAnswer.questionId == '-2021') {
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 5
										},
									});
									return
								} else if (currentAnswer.questionId == '-2022') {
									this.$router.replace({
										path: "/treat/medicalrecord",
										query: {
											num: 6
										},
									});
									return
								} else {
									this.$router.replace("/microscope/transfer");
								}
							} else {
								this.$router.replace("/microscope/transfer");
							}
							this.$router.replace("/microscope/transfer");
						});
					} else {
						this.VISUAL_EXAMINATION({
							key: "clear",
							value: []
						});
						//判定存储的是否有题目，有的话跳转题目，没有跳转显微镜页面
						if (res.data.data.currentAnswer) {
							let currentAnswer = res.data.data.currentAnswer
							this.handleMicroscope({
								key: "slideType",
								value: parseInt(currentAnswer.paperId),
							});
							let answers = JSON.parse(currentAnswer.answers)

							this.handleMicroscope({
								key: "detail3",
								value: answers.detail1,
							});
							this.handleMicroscope({
								key: "detail4",
								value: answers.detail2,
							});
							if (currentAnswer.questionId == '-2') {
								this.$router.replace("/microscope/slide");
								return
							} else if (currentAnswer.questionId == '-1') {
								this.$router.replace("/microscope/luminance");
								return
							} else if (currentAnswer.questionId == '0') {
								this.$router.replace("/microscope/lowPowe");
								return
							} else if (currentAnswer.questionId == '1') {
								this.$router.replace("/microscope/highPoweOne");
								return
							} else if (currentAnswer.questionId == '2') {
								this.$router.replace("/microscope/highPoweTwo");
								return
							} else if (currentAnswer.questionId == '3') {
								this.$router.replace("/microscope/highPoweThree");
								return
							} else if (currentAnswer.questionId == '4') {
								this.handleMicroscope({
									key: "microscopeModleTime",
									value: false
								});
								this.handleMicroscope({
									key: "activeIndex",
									value: 2
								});
								this.$router.replace("/microscope/transfer");
								return
							}
						} else {
							this.handleMicroscope({
								key: "slideType",
								value: 0,
							});
							this.handleMicroscope({
								key: "detail3",
								value: [],
							});
							this.handleMicroscope({
								key: "detail4",
								value: [],
							});
							this.$router.replace("/microscope/start");
						}
					}
				});
			},
			//清除数据
			clearData() {
				this.VISUAL_EXAMINATION({
					key: "clear",
					value: []
				});
				this.handleMicroscope({
					key: "clear",
					value: []
				});
			},

			// 去学习
			handleGoKcqd() {
				wx.miniProgram.navigateTo({
					url: "/pages/knowledge/ktqd?type=2"
				});
			},

			// 回到小程序
			goPageBefore() {
				wx.miniProgram.navigateBack({});
				// wx.miniProgram.navigateTo({ url: "/pages/home/index" });
			},

			// 关闭弹出框
			handleCloseError() {
				this.errorShow = false;
				if (this.errortext1 === "登录异常") {
					wx.miniProgram.navigateBack({});
					// wx.miniProgram.navigateTo({ url: "/pages/home/index" });
				}
			},

			// 初始化登录
			getInit() {
				let data;
				if (!this.isdebugger) {
					data = {
						hospitalName: this.$route.query.hospitalName,
						nickName: this.$route.query.nickName,
						sign: this.$route.query.sign,
						timestamp: this.$route.query.timestamp,
						userId: this.$route.query.userId,
					};
				} else {
					// data = {
					//   hospitalName: '北京中国农业大学动物医院',
					//   nickName: '肖方',
					//   sign: '5963fa98e40a30063b5786925fc3c7c7',
					//   timestamp: '1690862790607',
					//   userId: '2564983a18024060ac4ee8778960f955'
					// }
					// data = {
					// 	hospitalName: "北京市恒诺动物医院",
					// 	nickName: "222",
					// 	sign: "5b9b81df6ca2ac12d975a3fa8f35e3a3",
					// 	timestamp: "1714151639462",
					// 	userId: "66",
					// };
					data = {
						hospitalName: "北京市恒诺动物医院",
						nickName: "zhang6",
						sign: "fa9da51f1caa29604edd1b2fae7ebe2f",
						timestamp: "1773733229936",
						userId: "839",
					};
				}
				login(data).then((res) => {
					setToken(res.data.access_token);
					this.loadingShow = false;
					this.getIsEnd();
				});
			},

			// 清除次数
			cleanExamData() {
				cleanMyExamData().then((res) => {});
			},
			// 初始化
			getIsEnd() {
				isEnd().then((res) => {
					if (res.data.code === 0) {
						this.isEnd = res.data.data;
					}
				});
				getIndexUserData().then((res) => {
					this.initData = res.data.data;
				});
			},

			// 关闭
			handleClose() {
				this.isShow = false;
			},

			// 打开
			handleShow() {
				this.isShow = true;
			},

			// 开始考核
			handleGoMicroscope() {
				if (this.isEnd) {
					this.errortext1 = "当前考核已截止";
					this.errortext2 = "请查看其他活动";
					this.errorShow = true;
				} else if (this.initData && this.initData.remainingTimes === 0) {
					this.popupNode = true
					// this.$toast("您的考核次数为0");
				} else {
					this.handleGoMicroscopeStart()

				}
			},

			// 点击放大
			handleImgAmplify(type) {
				this.imgStatus = type;
				this.imgAmplify = true;
			},

			// 检查页面参数
			check() {
				alert(
					"hospitalName",
					this.$route.query.hospitalName,
					"nickName",
					this.$route.query.nickName,
					"sign",
					this.$route.query.sign,
					"timestamp",
					this.$route.query.timestamp,
					"userId",
					this.$route.query.userId
				);
			},
			//跳转领取次数
			nodeBtnClick() {
				this.popupNode = false
				wx.miniProgram.navigateTo({
					url: "/pages/knowledge/numberAnswers?type=2"
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.flexAuto {
		width: 50px;
		height: 50px;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	.home-page {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/bgx.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;

		.suspension {
			position: fixed;
			top: 52px;
			right: 0;
			width: 176px;
			height: 72px;
			background: #043883;
			border-radius: 20px 0 0 20px;
			font-size: 28px;
			font-family: HarmonyOS Sans SC;
			font-weight: 500;
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.bg {
			height: 130px;
		}

		.bottom-box {
			width: 688px;
			height: 683px;
			margin-top: 40px;
			position: relative;
			background-image: url("./../../assets/home/xshomebg.png");
			// background: image("./../../assets/home/home-bg.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;

			.bottom-title {
				font-size: 24px;
				font-weight: 400;
				color: rgba(43, 184, 176, 1);
				text-align: center;
				padding-top: 110px;

				div {
					color: #1845cc;
				}
			}

			.title-num {
				font-size: 28px;
				font-weight: 400;
				letter-spacing: 0px;
				line-height: 52px;
				color: rgba(91, 129, 133, 1);
				text-align: center;
				padding-top: 28px;
			}
		}

		.content {
			width: 686px;
			// background: rgba(255, 255, 255, 0.3);
			// box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;
			margin: 0 auto;
			margin-top: 40px;
			padding-top: 1px;

			.book {
				width: 686px;
				border-radius: 49px;
				margin: 0 auto;

				img {
					display: block;
					width: 686px;
				}
			}

			.btn {
				width: 292px;
				height: 72px;
				border-radius: 36px;
				margin: 0 auto;
				font-size: 32px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				line-height: 72px;
				text-align: center;
				margin-top: 50px;
				color: #ffffff;
				background: linear-gradient(132.17deg,
						#00bbb1 0%,
						#005a8d 64.42%,
						#ab3b7f 100%);

				img {
					display: inline;
					width: 47px;
					vertical-align: middle;
				}
			}

			.br {
				border: 1px dashed rgba(230, 230, 230, 1);
				margin-top: 32px;
				margin-bottom: 30px;
			}

			.txt {
				margin: 0 auto;
				border-radius: 16px;
				padding: 20px 32px 34px 32px;
				font-size: 22px;
				font-weight: 400;
				line-height: 36px;
				color: #000000;

				div {
					margin-bottom: 10px;
					font-size: 22px;
					color: rgba(102, 102, 102, 1);

					span {
						color: rgba(6, 59, 136, 1);
					}
				}
			}

			.microscopeFalse {
				margin-top: 140px;
				background: linear-gradient(90deg, #1e3c72, #2a5298);
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				color: #ffffff;
			}

			.treatTrue {
				margin-top: 80px;
				background: #e5e5e5;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				color: #333333;

				img {
					// margin-right: 90px;
				}
			}

			.microscopeTrue {
				margin-top: 140px;
				background: #e5e5e5;
				color: #333333;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
			}

			.treatFalse {
				margin-top: 80px;
				background: linear-gradient(90deg, #1e3c72, #2a5298);
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				color: #ffffff;

				img {
					// margin-right: 90px;
				}
			}
		}

		.van-popup {
			border-radius: 60px 60px 0 0;

			.dialog {
				position: relative;
				width: 100%;
				height: 1180px;
				background: linear-gradient(182deg,
						rgba(105, 251, 251, 0.65),
						rgba(255, 255, 255, 0.65),
						rgba(255, 255, 255, 1),
						rgba(255, 255, 255, 1));

				.close {
					position: absolute;
					top: 54px;
					right: 55px;
					width: 49px;
				}

				.dialogTitle {
					padding-top: 50px;
					font-size: 50px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #333333;
					text-align: center;
					margin-bottom: 38px;

					.link {
						vertical-align: middle;
						width: 50px;
						height: 50px;
						margin-right: 26px;
						margin-top: -8px;
					}
				}

				.itemTxt {
					height: 1100px;
					overflow: auto;
					margin-bottom: 80px;

					.icon {
						width: 100%;
						margin-top: 20px;
					}
				}

				.dialogPrize {
					// margin-top: 140px;
					font-size: 50px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #333333;
					text-align: center;
					margin-bottom: 28px;

					.prize {
						vertical-align: middle;
						width: 50px;
						height: 50px;
						margin-right: 26px;
						margin-top: -8px;
					}
				}

				.prizeBox {
					display: flex;
					margin: 0 75px;
					margin-bottom: 20px;

					.itemTitle {
						color: #1e3c72 !important;
					}

					.textBottom {
						.text {
							font-size: 25px;
							font-weight: 500;
							color: #4c4c4c;
							line-height: 40px;
							text-align: -webkit-left;
						}
					}

					.item {
						width: 280px;

						img {
							width: 280px;
							height: 280px;
							object-fit: cover;
						}

						div {
							text-align: center;
							font-size: 28px;
							font-family: HarmonyOS Sans SC;
							font-weight: 500;
							color: #4c4c4c;
							margin-top: 35px;
						}
					}

					.item:last-child {
						margin-left: auto;
					}
				}
			}
		}
	}

	::v-deep .van-dialog {
		border-radius: 0;
		width: 92%;

		.van-dialog__content {
			width: 100%;
		}

		.imgAmplify {
			width: 100%;

			img {
				width: 100%;
			}
		}
	}

	.mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		background: rgba(255, 255, 255, 0.8);
	}

	.dialog {
		width: 612px;
		height: 440px;
		position: fixed;
		z-index: 2;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;

		background: #ffffff;
		box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
		border-radius: 60px;

		.text {
			font-size: 35px;
			font-family: HarmonyOS Sans SC;
			font-weight: bold;
			color: #333333;
			line-height: 60px;
			text-align: center;
		}

		.mt130 {
			margin-top: 120px;
		}

		.btn {
			width: 247px;
			margin: 0 auto;
			height: 80px;
			line-height: 80px;
			text-align: center;
			font-size: 35px;
			font-family: HarmonyOS Sans SC;
			font-weight: 500;
			margin-top: 80px;
			color: #ffffff;
			border-radius: 40px;
			background: linear-gradient(90deg, #1e3c72, #2a5298);
		}
	}

	.gz {
		// margin-bottom: -66px;
		width: 750px;
		height: 1180px;

		border-radius: 16px 16px 0px 0px;
		// background: linear-gradient(180deg,
		// 		rgba(202, 247, 255, 1) 0%,
		// 		rgba(255, 255, 255, 1) 100%);
		background: linear-gradient(180deg, rgba(202, 247, 255, 1) 0%, rgba(255, 255, 255, 1) 25%);

		.title {
			padding: 40px 30px;
			position: relative;

			.txt {
				font-size: 40px;
				font-weight: 700;
				letter-spacing: 0px;
				line-height: 54.88px;
				color: rgba(51, 51, 51, 1);
				text-align: center;
				vertical-align: top;
			}

			.close {
				position: absolute;
				right: 43px;
				top: 56px;

				img {
					width: 24px;
				}
			}
		}

		.img {
			height: 1045px;
			overflow: auto;
			padding: 0 33px 33px 33px;

			img {
				width: 100%;

			}
		}
	}

	.node-view {
		width: 562px;
		padding-bottom: 67px;
		background-color: #FFFFFF;
		// border-radius: 40px;
		display: flex;
		flex-direction: column;
		align-items: center;

	}

	.node-view-title {
		color: #1A1A1A;
		font-size: 40px;
		font-weight: bold;
		margin-top: 95px;
		text-align: center;
	}

	.node-view-des {
		color: #666666;
		font-size: 32px;
		margin-top: 49px;
		width: 458px;
		text-align: center;
	}

	.node-view-btn {
		width: 260px;
		height: 72px;
		border-radius: 36px;
		background: linear-gradient(90deg, #0097A4 0%, #004F89 100%);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 54px;
		color: #FFFFFF;
		font-size: 28px;
	}

	.node-view-btn-see {
		width: 260px;
		height: 72px;
		border-radius: 36px;
		background-color: #FFFFFF;
		border: 1px solid #007E9A;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 33px;
		color: #007E9A;
		font-size: 28px;
	}
</style>